import TongHopDonTreHanXuLy from './TongHopDonTreHanXuLy.jsx';
import TongHopDonTreHanGiaiQuyet from './TongHopDonTreHanGiaiQuyet.jsx';
import TongHopKetQuaGQDTCPage from './TongHopKetQuaGQDTCPage.jsx';
import TongHopKetQuaTiepCongDanPage from './TongHopKetQuaTiepCongDanPage.jsx';
import TongHopKetQuaGQDKNPage from './TongHopKetQuaGQDKNPage.jsx';
import TongHopKetQuaXuLyDonPage from './TongHopKetQuaXuLyDonPage.jsx';
import TongHopKetQuaThanhTraHanhChinhPage from './TongHopKetQuaThanhTraHanhChinhPage.jsx';
import TongHopKetQuaThanhTraDatDaiPage from './TongHopKetQuaThanhTraDatDaiPage.jsx';
import TongHopKetQuaThanhTraChuyenNganhPage from './TongHopKetQuaThanhTraChuyenNganhPage.jsx';
import TongHopKetQuaThanhTraXayDungCoBanPage from './TongHopKetQuaThanhTraXayDungCoBanPage.jsx';
import TongHopKetQuaThanhTraTaiChinhNganSachPage from './TongHopKetQuaThanhTraTaiChinhNganSachPage.jsx';
import TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage from './TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage.jsx';
import TongHopKetQuaThanhTraLaiPage from './TongHopKetQuaThanhTraLaiPage.jsx';
import TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage from './TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage.jsx';
import TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage from './TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage.jsx';
import KetQuaKiemTraChiTietDoanhNghiepPage from './KetQuaKiemTraChiTietDoanhNghiep.jsx';
import KetQuaKiemTraTheoKeHoachDoanhNghiepPage from './KetQuaKiemTraTheoKeHoachDoanhNghiep.jsx';
import KetQuaKiemTraDotXuatDoanhNghiepPage from './KetQuaKiemTraDotXuatDoanhNghiep.jsx';
import TongHopKetQuaThanhTraPage from './TongHopKetQuaThanhTra.jsx';
import TongHopKetQuaThanhTraThamNhungPage from './TongHopKetQuaThanhTraThamNhungPage.jsx';

export {
  TongHopDonTreHanXuLy,
  TongHopDonTreHanGiaiQuyet,
  TongHopKetQuaGQDTCPage,
  TongHopKetQuaTiepCongDanPage,
  TongHopKetQuaGQDKNPage,
  TongHopKetQuaXuLyDonPage,
  TongHopKetQuaThanhTraHanhChinhPage,
  TongHopKetQuaThanhTraDatDaiPage,
  TongHopKetQuaThanhTraChuyenNganhPage,
  TongHopKetQuaThanhTraXayDungCoBanPage,
  TongHopKetQuaThanhTraTaiChinhNganSachPage,
  TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage,
  TongHopKetQuaThanhTraLaiPage,
  TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage,
  TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage,
  KetQuaKiemTraChiTietDoanhNghiepPage,
  KetQuaKiemTraTheoKeHoachDoanhNghiepPage,
  KetQuaKiemTraDotXuatDoanhNghiepPage,
  TongHopKetQuaThanhTraPage,
  TongHopKetQuaThanhTraThamNhungPage
}


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/index.js